import { displayUserTimeZone, parseDateTime } from "utils/dates/date.utils";

export const getWeatherTimeString = (dateTime, widgetMode = false) => {
  const date = parseDateTime(dateTime);
  if (!date) return '';

  const hours24 = date.getHours();
  const hours12 = hours24 % 12 || 12; // Convert to 12-hour format, treating 0 as 12
  const minutes = String(date.getMinutes()).padStart(2, '0'); // Ensure minutes are always two digits (add leading zero if needed)
  const amPm = hours24 >= 12 ? 'PM' : 'AM';
  const userTimezone = displayUserTimeZone()

  return !widgetMode ? `${hours12}:${minutes} ${amPm} ${userTimezone}` : `${hours12} ${amPm}`;
};
